import { B as g, D as i, I as a, _ as r, A as s } from "./index-B1VzWttN.js";
export {
  g as H,
  i as HighlightSegmentMiddleware,
  a as MetricCategory,
  r as __testing,
  s as configureElectronHighlight
};
//# sourceMappingURL=index.js.map
